import { z } from 'zod';
import { CalibrationOperationType } from './types';

export type CalibrationTaskFormSchema = z.infer<typeof calibrationTaskFormSchema>;
export type PoType = CalibrationTaskFormSchema['poList'][number];

const poSchema = z.object({
	id: z.number(),
	name: z.string().nonempty(),
	msIds: z.array(z.number()),
	ttmsIdPrimary: z.coerce
		.number({ invalid_type_error: 'TTMS ID must be a number' })
		.positive({ message: 'TTMS ID must be a number' }),
	ttmsIdSecondary: z.number(),
	algorithm: z.coerce.number(),
	cx: z.number(),
	cy: z.number(),
	timeAdjustment: z.number(),
	kvClass: z.number(),
	latestKofFile: z.string(),
	primaryCalibrationFactor: z.number()
});

export const calibrationTaskFormSchema = z
	.object({
		name: z.string().nonempty(),
		id: z.number(),
		startDate: z
			.union([
				z
					.date({ required_error: 'Start date is required' })
					.max(new Date(), { message: "Start Date can't be in the future" }),
				z.null()
			])
			.refine(date => date instanceof Date && !isNaN(date.getTime()), {
				message: 'Start date is required'
			}),
		endDate: z
			.union([
				z
					.date({ required_error: 'End date is required' })
					.max(new Date(), { message: "End Date can't be in the future" }),
				z.null()
			])
			.refine(date => date instanceof Date && !isNaN(date.getTime()), {
				message: 'End date is required'
			}),
		interceptFlag: z.boolean(),
		referenceData: z.instanceof(File).optional(),
		historicalData: z.instanceof(File).optional(),
		taskType: z.nativeEnum(CalibrationOperationType),
		poList: z.array(poSchema)
	})
	.refine(data => data.startDate && data.endDate && data.endDate.getTime() > data.startDate.getTime(), {
		message: 'End date must be after the start date',
		path: ['endDate']
	});
